module.exports = __webpack_public_path__ + "img/minimalistic-science-banner-with-pills.255f3744.jpeg";